import { useCurrentDate } from 'hooks/date-hook';
import { useHttpClient } from 'hooks/http-hook';
import moment from 'moment';
import { useAuth } from "providers/AuthProvider";
import { useR2 } from 'providers/R2Provider';
import { useCallback, useEffect, useRef, useState } from 'react';

const useMainNav = ({ userCreatedPages }) => {
  const { mainNavOpen, setMainNavOpen } = useR2();
  const { token, isLoggedIn, logout } = useAuth();
  const currentDate = useCurrentDate();
  const currentDateString = moment(currentDate).format('YYYY-MM-DD').toString();
  const yesterdayDateString = moment(currentDate).subtract(1, 'days').format('YYYY-MM-DD');
  const [slideCount, setSlideCount] = useState(0);
  const [currentSlide, setCurrentSlide] = useState(0);
  const slidesContainerRef = useRef(null);
  const { sendRequest } = useHttpClient();
  const userCreatedPagesAtoZ = userCreatedPages.sort((a, b) => a.title.toLowerCase().localeCompare(b.title.toLowerCase()));
  const [lastFiveRecordedDays, setLastFiveRecordedDays] = useState();

  // Fetch Days function
  const fetchLastFiveRecordedDays = useCallback(async () => {
    try {
      const response = await sendRequest(`${process.env.REACT_APP_BACKEND_URL}/days/${currentDateString}/5`, 'GET', null, {Authorization: `Bearer ${token}`});
      return response.days;
    } catch (err) {
      console.error('error', err);
    }
  }, [sendRequest, currentDateString, token]);

  // Get last five recorded Days for Today/Yesterday links
  useEffect(() => {
    fetchLastFiveRecordedDays().then(fetchedDays => setLastFiveRecordedDays(fetchedDays));
  }, [currentDateString, fetchLastFiveRecordedDays, mainNavOpen]);

  const dayCreated = (day) => {
    if (!lastFiveRecordedDays) return;
    let dateString = currentDateString;
    if (day === 'yesterday') dateString = yesterdayDateString;
    return !!lastFiveRecordedDays.some(x => x.dateString === dateString);
  }

  // Count up all the nav slides after render
  useEffect(() => {
    const slides = document.querySelectorAll('.mainnav__slide');
    setSlideCount(slides.length);
  }, []);

  useEffect(() => {
    if (slidesContainerRef.current) {
      const slide = slidesContainerRef.current.querySelector('.mainnav__slide');
      if (slide) {
        const slideWidth = slide.offsetWidth;
        const scrollAmount = currentSlide * slideWidth;

        slidesContainerRef.current.scrollTo({
          left: scrollAmount,
          behavior: 'smooth',
        });
      }
    }
  }, [currentSlide]);

  const handleSlideNavClick = (index) => {
    setCurrentSlide(index);
  };

  const signInOut = () => {
    if (isLoggedIn) logout();
    setMainNavOpen(false);
  }

  return {
		signInOut,
    currentDateString,
    currentSlide,
    dayCreated,
    handleSlideNavClick,
    slideCount,
    slidesContainerRef,
    userCreatedPagesAtoZ,
    yesterdayDateString,
  };
};

export default useMainNav;